<script setup lang="ts">
import { NConfigProvider, NDialogProvider, NLoadingBarProvider, NMessageProvider } from 'naive-ui';
import { RouterView } from 'vue-router';

import Theme from '@/style/themeConfig';
</script>

<template>
  <n-config-provider :theme-overrides="Theme">
    <n-message-provider>
      <n-dialog-provider>
        <n-loading-bar-provider>
          <RouterView />
        </n-loading-bar-provider>
      </n-dialog-provider>
    </n-message-provider>
  </n-config-provider>
</template>

<style scoped></style>
